import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { TextLink } from '../../typography/TextLink/TextLink'
import { breakpointMax, calcRem, colors, fonts, metrics } from '../../__styling'
import { StyledLink } from '../TheWestHeader/TheWestHeader.styled'

export const PuzzlesBreachWrap = styled('div')(() => ({
    width: '100%',
    '&>p': {
        paddingLeft: calcRem(18),
    },
}))

export const PuzzlesBreachCTAWrap = styled('div')<{
    bgImage?: string
    noBanner?: boolean
}>(({ bgImage, noBanner }) => [
    {
        position: 'relative',
        width: 'calc(100% - 24px)',
        margin: 'auto',
        marginTop: noBanner ? 0 : calcRem(40),
        padding: calcRem(30),
        borderRadius: calcRem(16),
        background: tokens.thewest.colors.palette.breachLightBlue,
        overflow: 'hidden',

        '&::after': {
            content: `url(${bgImage})`,
            position: 'absolute',
            right: '11%',
            top: calcRem(-125),
            width: calcRem(300),
            height: calcRem(300),

            [breakpointMax('lg')]: {
                right: calcRem(150),
                width: calcRem(200),
                height: calcRem(200),
            },
            [breakpointMax('md')]: {
                width: calcRem(60),
                height: calcRem(60),
            },
            [breakpointMax('xxs')]: {
                display: 'none',
            },
        },

        [breakpointMax('xxs')]: {
            width: '100%',
            padding: '20px',
        },
    },
])

export const CTAHeading = styled('h2')(({ theme }) => ({
    fontSize: calcRem(36),
    fontWeight: 700,
    lineHeight: calcRem(36),
    fontFamily: theme.fonts.sansSerif,
    margin: `0 0 ${calcRem(16)}`,
}))

export const CTASubHeading = styled('p')(({ theme }) => ({
    fontSize: calcRem(18),
    fontWeight: 400,
    fontFamily: theme.fonts.sansSerif,
    lineHeight: calcRem(24),
}))

export const ButtonWrap = styled('div')(() => ({
    display: 'flex',
    marginTop: calcRem(40),

    [breakpointMax('xs')]: {
        flexWrap: 'wrap',
        marginTop: calcRem(20),
        marginBottom: calcRem(20),
    },

    [breakpointMax('xxs')]: {
        flexDirection: 'unset',
    },
}))
export const SubscribeButton = styled(StyledLink)(({ theme }) => ({
    // Why the hard fixed height & width??
    height: calcRem(54),
    width: calcRem(200),

    border: 'none',
    borderRadius: calcRem(8),

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    background: theme.sectionValues.primaryColor,
    padding: calcRem(metrics.thewest.margins.sm, metrics.thewest.margins.lg),

    fontFamily: fonts.thewest.sansSerif,
    fontSize: calcRem(14),
    textTransform: 'uppercase',
    fontWeight: 700,
    textDecoration: 'none',
    color: colors.white,

    '&:hover, &:focus': {
        textDecoration: 'none',
        color: colors.white,
    },
    '&:focus': {
        background: colors.thewest.greyKoala,
    },
    '&:hover': {
        background: colors.thewest.greyGorilla,
    },

    [breakpointMax('xxs')]: {
        width: '100%',
        fontWeight: 600,
    },
}))

export const BottomTextWrap = styled('div')(() => ({
    display: 'block',
    marginTop: calcRem(18),
}))

export const InfoText = styled('p')(({ theme }) => ({
    fontFamily: theme.fonts.sansSerif,
}))

export const InfoTextLink = styled(TextLink)(({ theme }) => ({
    fontFamily: theme.fonts.sansSerif,
    textDecoration: 'underline',
}))

export const PromoRibbon = styled('div')(({ theme }) => ({
    height: calcRem(50),
    padding: calcRem(4, 20),
    marginLeft: calcRem(20),
    background: tokens.thewest.colors.palette.breachBgLightBlue,
    color: tokens.thewest.colors.palette.westblue,
    borderRadius: '100px',
    border: 'none',
    fontSize: calcRem(22),
    fontWeight: 700,
    fontFamily: theme.fonts.sansSerif,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',

    [breakpointMax('xxs')]: {
        margin: 0,
        marginBottom: calcRem(10),
        alignSelf: 'flex-start',
    },
}))
